import React, { useEffect } from "react";
import { oidcLogout } from "shared-auth";
import { FullPageSpinner } from "shared/modules/Common/FullPageSpinner";

const Logout = () => {
  useEffect(() => {
    oidcLogout();
  }, []);

  return <FullPageSpinner />;
};

export default Logout;
